
import { useCallback, useMemo } from "react";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { useQueryClient } from "@tanstack/react-query";
import type { ArticuloFijo } from "./ModalEditarUbicacion";
import type { Respuesta } from "@/ts/typings/clases";
import { notificacion, notificacionError } from "@/components/Alerts";
import { CommonFeatures } from "@/hooks/useTanstackTable";

export function TablaFijos(props: { readonly data: ArticuloFijo[]; readonly idUbicacion: string; readonly zona: string; readonly fila: string; readonly openEditar: (art: ArticuloFijo) => void; }) {
	const { openEditar } = props;
	const queryClient = useQueryClient();

	const eliminarArticuloFijo = useCallback((id: number) => {
		void sendAjaxRequest<Respuesta>("POST", "/api/v1/eliminarArticuloFijo", { id }).then((respuesta) => {
			if (respuesta.tipo == "error") {
				notificacionError(respuesta.message ?? "Error al eliminar el artículo fijo.");
				return;
			}

			notificacion("Articulo eliminado");
			void queryClient.invalidateQueries({ queryKey: ["getDatosUbicacion", props.idUbicacion] });
			void queryClient.invalidateQueries({ queryKey: ["getEstanteria", props.zona, props.fila] });
		});
	}, [props.fila, props.idUbicacion, props.zona, queryClient]);



	const { columns, features } = useMemo(() => Columns(eliminarArticuloFijo, openEditar), [eliminarArticuloFijo, openEditar]);


	return (
		<TypedTable
			className="dataTable display"
			data={props.data}
			columns={columns}
			features={features}

			pagination
			globalSearch

			noResultsMessage="No hay artículos fijos asignados"
			errorMessage="Error cargando los artículos fijos"
			isLoading={false}
			isError={false}
		/>
	);
}



function Columns(eliminarArticuloFijo: (id: number) => void, openEditar: (art: ArticuloFijo) => void) {
	const columnHelper = createColumnHelper<typeof features, ArticuloFijo>();
	const features = tableFeatures(CommonFeatures);

	const getAccionArticuloFijo = (linea: ArticuloFijo) => {
		return (
			<div className="clickable" style={{ display: "flex", justifyContent: "space-around" }}>
				<a target="_self" className="main-color btnIcon" onClick={() => { openEditar(linea); }}>
					<i className="fa fa-pen-to-square" style={{ fontSize: 25, margin: "0 10px" }} />
				</a>
				<a target="_self" className="main-color btnIcon" onClick={() => { eliminarArticuloFijo(linea.id); }}>
					<i className="fa fa-trash" style={{ fontSize: 25, margin: "0 10px" }} />
				</a>
			</div>
		);
	};

	const columns = columnHelper.columns([
		columnHelper.accessor("idArticulo", { header: "Artículo", meta: { className: "dt-center" } }),
		columnHelper.accessor("minimo", { header: "Mínimo", meta: { className: "dt-center" } }),
		columnHelper.accessor("maximo", { header: "Máximo", meta: { className: "dt-center" } }),
		columnHelper.display({ id: "acciones", header: "", meta: { className: "dt-center" }, cell: (info) => getAccionArticuloFijo(info.row.original) }),
	]);
	return { columns, features };
}